export default __webpack_public_path__ + "static/media/puncture.2b3774e9.png";